// import React, { useState, useEffect } from "react";
// import { Box, Typography, Grid, Paper, Skeleton, alpha } from "@mui/material";
// import httpclient from "../../../../Utils";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { ORDER_STATUSES } from "./constants";

// const OrderCounts = ({ onCardClick, activeTab }) => {
//   const [countData, setCountData] = useState({
//     totalOrder: 0,
//     totalWaitingForPickup: 0,
//     totalInProgressOrder: 0,
//     totalPausedOrder: 0,
//     totalInTransitOrder: 0,
//     totalReadyForDeliveryOrder: 0,
//     totalCompletedOrder: 0,
//     totalUnloadOrder: 0,
//     totalCanceledOrder: 0,
    
// totalDropToDepo : 0,

//   });
//   const [loading, setLoading] = useState(false);

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   const fetchCountData = async () => {
//     setLoading(true);
//     try {
//       const res = await httpclient.get(
//         "/delivery/orders/data/statuswise-count"
//       );
//       const { data } = res;

//       if (data.status === 200) {
//         setCountData(data.data);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCountData();
//   }, []);

//   // Refetch counts when activeTab changes to ensure data is in sync
//   useEffect(() => {
//     if (activeTab) {
//       fetchCountData();
//     }
//   }, [activeTab]);

//   const statCards = ORDER_STATUSES.map((status) => {
//     const value = countData[status.countKey];
//     return {
//       title: status.label,
//       value: value,
//       color: status.color,
//       icon: status.icon,
//       tabValue: status.value,
//       hasValue: value !== null && value !== undefined,
//     };
//   });

//   // Helper to format value with fallback for null/undefined
//   const formatValue = (value) => {
//     if (value === null || value === undefined) return "";
//     return value?.toLocaleString();
//   };

//   return (
//     <Box sx={{ mb: 4 }}>
//       <Paper
//         elevation={0}
//         sx={{
//           p: 2,
//           backgroundColor: "#ffffff",
//           borderRadius: 3,
//           border: "1px solid",
//           borderColor: "divider",
//           overflow: "hidden",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             mb: 2,
//             pb: 2,
//             borderBottom: "1px solid",
//             borderColor: "divider",
//           }}
//         >
//           <Typography
//             variant="body1"
//             sx={{
//               fontWeight: 600,
//               color: "text.primary",
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             }}
//           >
//             <Box
//               component="span"
//               sx={{
//                 width: 3,
//                 height: 18,
//                 borderRadius: 1,
//                 bgcolor: "primary.main",
//               }}
//             />
//             Orders Count Overview
//           </Typography>
//         </Box>

//         {/* Cards Grid - All cards equal height */}
//         <Grid container spacing={2}>
//           {statCards.map((card, index) => {
//             const isActiveCard = activeTab === card.tabValue;

//             return (
//               <Grid
//                 item
//                 xs={6}
//                 sm={4}
//                 md={3}
//                 lg={1.33} // 9 cards in one row on large screens
//                 key={index}
//                 sx={{
//                   display: "flex", // Important for equal height
//                 }}
//               >
//                 <Paper
//                   elevation={0}
//                   onClick={() => onCardClick?.(null, card.tabValue)}
//                   sx={{
//                     px: 1,
//                     py: 2,
//                     borderRadius: 2,
//                     width: "100%", // Take full width of grid item
//                     minHeight: 100, // Fixed minimum height for all cards
//                     borderTop: "1px solid",
//                     borderLeft: "1px solid",
//                     borderRight: "1px solid",
//                     borderBottom: isActiveCard
//                       ? `4px solid ${card.color}`
//                       : `1px solid ${alpha(card.color, 0.2)}`,
//                     borderTopColor: isActiveCard
//                       ? card.color
//                       : alpha(card.color, 0.2),
//                     borderLeftColor: isActiveCard
//                       ? card.color
//                       : alpha(card.color, 0.2),
//                     borderRightColor: isActiveCard
//                       ? card.color
//                       : alpha(card.color, 0.2),
//                     backgroundColor: isActiveCard
//                       ? alpha(card.color, 0.12)
//                       : alpha(card.color, 0.03),
//                     transition: "all 0.2s ease-in-out",
//                     cursor: "pointer",
//                     "&:hover": {
//                       borderColor: card.color,
//                       backgroundColor: alpha(card.color, 0.08),
//                       transform: "translateY(-2px)",
//                       boxShadow: `0 4px 12px ${alpha(card.color, 0.15)}`,
//                     },
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "center", // Center content vertically
//                     textAlign: "center",
//                     position: "relative",
//                     overflow: "hidden",
//                     flexGrow: 1, // Make all cards grow to same height
//                   }}
//                 >
//                   {/* Background accent */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: 3,
//                       background: `linear-gradient(90deg, ${alpha(
//                         card.color,
//                         0.3
//                       )} 0%, ${card.color} 50%, ${alpha(
//                         card.color,
//                         0.3
//                       )} 100%)`,
//                     }}
//                   />

//                   {/* Value - Always show something */}
//                   <Typography
//                     variant="body1"
//                     sx={{
//                       fontWeight: 700,
//                       color: card.hasValue
//                         ? "text.primary"
//                         : alpha("#000", 0.3),
//                       fontSize: { xs: "1.7rem", sm: "2rem" },
//                       lineHeight: 1.2,
//                       width: "100%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       flexShrink: 0, // Prevent from shrinking
//                     }}
//                   >
//                     {loading ? (
//                       <Skeleton
//                         width="80%"
//                         height={40}
//                         animation="wave"
//                         sx={{ mx: "auto" }}
//                       />
//                     ) : (
//                       formatValue(card.value)
//                     )}
//                   </Typography>

//                   {/* Title - Always show, fixed height */}
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "text.secondary",
//                       fontSize: "0.75rem",
//                       fontWeight: isActiveCard ? 600 : 400,
//                       textTransform: "uppercase",
//                       letterSpacing: "0.5px",
//                       width: "100%",
//                       minHeight: 24, // Fixed height for title
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       flexShrink: 0, // Prevent from shrinking
//                     }}
//                   >
//                     {loading ? (
//                       <Skeleton
//                         width="70%"
//                         height={20}
//                         animation="wave"
//                         sx={{ mx: "auto" }}
//                       />
//                     ) : (
//                       card.title
//                     )}
//                   </Typography>

//                   {/* Subtle color indicator - always show */}
//                   <Box
//                     sx={{
//                       mt: 1,
//                       width: isActiveCard ? 72 : 24,
//                       height: isActiveCard ? 3 : 2,
//                       borderRadius: 1,
//                       bgcolor: card.color,
//                       opacity: isActiveCard ? 1 : 0.7,
//                       transition: "all 0.2s ease-in-out",
//                       flexShrink: 0, // Prevent from shrinking
//                     }}
//                   />
//                 </Paper>
//               </Grid>
//             );
//           })}
//         </Grid>

//         {/* Alternative: Using CSS Grid for better equal height control */}
//         {false && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: {
//                 xs: "repeat(2, 1fr)",
//                 sm: "repeat(4, 1fr)",
//                 md: "repeat(8, 1fr)",
//               },
//               gap: 2,
//             }}
//           >
//             {statCards.map((card, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   height: "100%", // All cards same height
//                 }}
//               >
//                 {/* Same card content as above */}
//               </Box>
//             ))}
//           </Box>
//         )}
//       </Paper>

//       {/* Add CSS animation for pulse effect */}
//       <style jsx global>{`
//         @keyframes pulse {
//           0% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0.5;
//           }
//           100% {
//             opacity: 1;
//           }
//         }
//       `}</style>
//     </Box>
//   );
// };

// export default OrderCounts;



import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Paper, Skeleton, alpha } from "@mui/material";
import httpclient from "../../../../Utils";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import { useTimer } from "../../../../Components/Context/TimerContext";

const OrderCounts = ({
  onCardClick,
  activeTab,
  isToday = false,
  showAllCard = false,
  showWaitingCard = false,
  externalCounts = null,
  // Set by the Orders page (All Jobs/Today's Jobs), which pairs this with a
  // DriversPanel supplying externalCounts for every other status - keeps
  // that page's existing behavior untouched. Every other consumer (e.g. the
  // SuperAdmin Dashboard widget) has no externalCounts source, so it needs
  // the full baseline from this endpoint for every field, not just these two.
  restrictBaselineToAllAndWaiting = false,
}) => {
  const [countData, setCountData] = useState({
    totalOrder: 0,
    totalWaitingForPickup: 0,
    totalOverview: 0,
    totalWaitingQueue: 0,
    totalInProgressOrder: 0,
    totalPausedOrder: 0,
    totalInTransitOrder: 0,
    totalReadyForDeliveryOrder: 0,
    totalCompletedOrder: 0,
    totalUnloadOrder: 0,
    totalCanceledOrder: 0,
    totalDropToDepo: 0,
    totalPostpone: 0,
    totalSuspend: 0,
    totalReturn: 0,
  });
  const [orderStatusBlock, setOrderStatusBlock] = useState([]);
  const [loading, setLoading] = useState(false);

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();
  const seconds = useTimer();

  const fetchCountData = async (showLoading = true) => {
    if (showLoading) setLoading(true);
    const endpoint = isToday
      ? "/delivery/today-orders/data/statuswise-count"
      : "/delivery/orders/data/statuswise-count";
    try {
      const res = await httpclient.get(endpoint);
      const { data } = res;

      if (data.status === 200) {
        // orderStatusBlock is nested inside data.data alongside the counts,
        // not at the top level.
        if (data.data?.orderStatusBlock) {
          setOrderStatusBlock(data.data.orderStatusBlock);
        }

        if (restrictBaselineToAllAndWaiting) {
          // Orders page (All Jobs/Today's Jobs): every other status gets a
          // fresher, tab-specific count from the driver-list response (see
          // externalCounts below) - if this response resolved after that
          // one, blindly replacing the whole countData object here would
          // race and stomp the fresher numbers back to these older ones.
          // Merge just the two fields this endpoint exclusively owns.
          setCountData((prev) => ({
            ...prev,
            totalOrder: data.data.totalOrder,
            totalWaitingForPickup: data.data.totalWaitingForPickup,
          }));
        } else {
          // No paired DriversPanel/externalCounts here - this endpoint is
          // the only source, so use it as the full baseline for every field.
          setCountData(data.data);
        }
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCountData(true);
  }, []);


  useEffect(() => {
    if (activeTab) {
      fetchCountData(true);
    }
  }, [activeTab]);

  // Refetch when switching between All Jobs and Today Jobs
  useEffect(() => {
    fetchCountData(true);
  }, [isToday]);

  // Refresh in step with the shared dashboard countdown (RefreshTimerDisplay)
  // instead of running an independent 60s interval
  useEffect(() => {
    if (seconds === 0) {
      fetchCountData(false);
    }
  }, [seconds]);

  // The driver-list based tabs (everything except All/Waiting for Delivery)
  // already fetch a fresh statuswise_job_count alongside their own data, so
  // merge that in for a quicker/more accurate update - but never let it
  // touch "All" (totalOrder) or "Waiting for Delivery" (totalWaitingForPickup),
  // which stay sourced only from the statuswise-count endpoint above.
  useEffect(() => {
    if (!externalCounts) return;

    setCountData((prev) => ({
      ...prev,
      ...externalCounts,
      totalOrder: prev.totalOrder,
      totalWaitingForPickup: prev.totalWaitingForPickup,
    }));
  }, [externalCounts]);

  const statCards = orderStatusBlock
    .filter((status) => status.is_active !== 0)
    .slice()
    .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))
    .map((status) => ({
      title: status.name,
      value: status.data_count,
      color: status.color || "#9E9E9E",
      tabValue: status.code,
    }))
    .filter((card) => {
      // Hide "All" card unless ?all=true
      if (card.tabValue === "all" && !showAllCard) return false;
      // Hide "Waiting for Delivery" card unless ?waiting=true
      if (card.tabValue === "inQueue" && !showWaitingCard) return false;
      return true;
    });

  const formatValue = (value) => {
    if (value === null || value === undefined) return "";
    return value?.toLocaleString();
  };

  return (
    <Box sx={{ mb: 4, padding: "16px" }}>
      <Grid container spacing={1.5}>
        {statCards.map((card, index) => {
          const isActiveCard = activeTab === card.tabValue;
          const isAllCard = card.tabValue === "all";
          const cardBackground = isAllCard
            ? alpha(card.color, 0.2)
            : alpha(card.color, 0.1);
          const cardHoverBackground = isAllCard
            ? alpha(card.color, 0.28)
            : alpha(card.color, 0.15);
          const cardTextColor = isAllCard ? "#424242" : card.color;

          return (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={2}
              key={index}
              sx={{
                display: "flex",
              }}
            >
              <Box
                onClick={() => onCardClick?.(null, card.tabValue)}
                sx={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  backgroundColor: cardBackground,
                  border: isActiveCard ? `2px solid ${card.color}` : "1px solid transparent",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: cardHoverBackground,
                    borderColor: card.color,
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: cardTextColor,
                    textTransform: "capitalize",
                    flex: 1,
                    textAlign: "left",
                  }}
                >
                  {loading ? (
                    <Skeleton width="80%" height={18} animation="wave" />
                  ) : (
                    card.title
                  )}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: cardTextColor,
                    minWidth: "40px",
                    textAlign: "right",
                  }}
                >
                  {loading ? (
                    <Skeleton width="40px" height={25} animation="wave" />
                  ) : (
                    formatValue(card.value)
                  )}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default OrderCounts;